"use client";
import { useCurrency } from "@/app/providers/currencyContext";
import React from "react";
import { useTranslations } from "next-intl";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { Layout } from "@/dto/item";

interface SingleProductImageFocusedPriceProps {
  product: any;
  isGiftCardProduct: boolean;
  layout?: Layout;
}

export const SingleProductImageFocusedPrice = ({
  product,
  isGiftCardProduct,
  layout = "default",
}: SingleProductImageFocusedPriceProps) => {
  const { format } = useCurrency();
  const t = useTranslations("SingleProductImageFocusedPrice");

  const formatPrice = (price: number) => {
    return format(price);
  };

  if (!product.available) {
    return (
      <div
        className="flex items-center"
        data-testid={applyDataTestId(pom.products.productPrice)}
      >
        <p
          className={["line-through font-normal text-base leading-6"].join(" ")}
        >
          {formatPrice(product.price)}
        </p>
        <span
          className={["ml-2 truncate font-normal text-base leading-6"].join(
            " "
          )}
        >
          {t("soldOut")}
        </span>
      </div>
    );
  }

  return (
    <p
      className={`text-base ${
        layout === "enhanced" ? "font-medium" : "font-semibold"
      } sm:leading-6`}
      data-testid={applyDataTestId(pom.products.productPrice)}
    >
      {!isGiftCardProduct ? formatPrice(product.price) : t("customValue")}
    </p>
  );
};
